import React from 'react'
import {Context as AppContext} from '../../../contexts/App'

const ProductMetrics = () => {
    const app = React.useContext(AppContext)
    const { productMetrics } = app.metrics
    return (
        <>
            ProductMetrics
        </>

    )
}

export default ProductMetrics